<template>
<div class="px-4 sm:px-8 lg:px-0 bg-base md:bg-transparent">
    <div class="mx-auto my-12 w-full max-w-[640px] md:max-w-[1136px] bg-white rounded-lg shadow-md md:shadow-none px-4 sm:px-8 py-12 text-main">
        <div class="flex flex-col items-center gap-4 text-center pb-8">
            <h1 class="font-bold text-2xl leading-8">招待をお待ちください</h1>
            <div class="text-sm leading-5">
                <p>編集者として参加する場合は、チャンネルオーナーからの招待が必要です。</p>
                <p>招待が届くと画面に通知が表示され、編集者としてチャンネルに参加できるようになります。</p>
            </div>
            <p class="text-sm leading-5">※YouTubeチャンネルオーナーの方は、チャンネルの申請を進めてください。</p>
        </div>

        <div class="flex justify-center">
            <button
                type="button"
                class="btn-lg bg-white border border-placeholder text-main px-4 w-full md:w-auto"
                @click="goToApplication"
            >
                チャンネル申請へ
            </button>
        </div>
    </div>
</div>
</template>

<script setup>
import { useRouter } from 'vue-router';

const router = useRouter();

const goToApplication = () => {
    router.push({ name: 'ChannelApplicationForm' });
};
</script>
